import { useEffect } from "react";

const BlockerZ = () => {
  useEffect(() => {
    let devToolsTimeout;
    let isDevToolsOpen = false;
    // Anti-debugging measures with delay and confirmation
    const detectDevTools = () => {
      const startTime = Date.now();
      setInterval(() => {
        const timeDiff = Date.now() - startTime;
        if (timeDiff > 200 && !isDevToolsOpen) {
          // Increased threshold
          isDevToolsOpen = true;
          console.clear();
          // Optional: Show warning instead of immediate redirect
          //   alert("Developer tools are not allowed in this application.");
        }
      }, 1000); // Increased interval
    };
    // Detect dev tools through window size with tolerance
    const detectResize = () => {
      const threshold = 250; // Increased threshold
      clearTimeout(devToolsTimeout);
      devToolsTimeout = setTimeout(() => {
        const isDiff =
          window.outerHeight - window.innerHeight > threshold ||
          window.outerWidth - window.innerWidth > threshold;
        if (isDiff && !isDevToolsOpen) {
          isDevToolsOpen = true;
          console.clear();
          // Optional: Show warning instead of clearing content
          //   alert("Developer tools are not allowed in this application.");
        }
      }, 1000);
    };
    // Disable right-click with exceptions
    const disableRightClick = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
        return true; // Allow right-click in input fields
      }
      e.preventDefault();
      return false;
    };
    // Block specific keyboard shortcuts
    const blockShortcuts = (e) => {
      if (
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key === "I" || e.key === "J" || e.key === "C")) ||
        (e.ctrlKey && e.key === "U") ||
        e.key === "F12"
      ) {
        e.preventDefault();
        alert("This keyboard shortcut is disabled.");
      }
    };
    // Initialize security with softer measures
    const initSecurity = () => {
      detectDevTools();
      window.addEventListener("resize", detectResize);
      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", blockShortcuts);
    };
    initSecurity();
    // Cleanup
    return () => {
      clearTimeout(devToolsTimeout);
      window.removeEventListener("resize", detectResize);
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", blockShortcuts);
    };
  }, []);

  return null;
};

export default BlockerZ;
